import goods from '../_goods.json'

export default {
    namespaced: true,
    state: {
        allGoods: goods,
        goods: []
    },
    getters: {
        availableGoods (state) {
            return goods.filter(good => state.goods.findIndex(item => item.id === good.id) < 0)
        },

        goodInfoById: state => id => state.allGoods.find(good => good.id === id),
        goodById: state => id => state.goods.find(good => good.id === id)
    },
    actions: {
        reset ({commit}) {
            commit('reset')
        }
    },
    mutations: {
        add (state, {regionId, goodId}) {
            const good = goods.find(good => good.id === goodId)

            state.goods.push({
                ...good,
                regionId: regionId
            })
        },

        reset (state) {
            state.goods = []
        }
    }
}
